<template>
    <div id="app">
        <Header/>

        <div class="divContainer">
            <transition name="page" mode="out-in">
                <router-view/>
            </transition>
        </div>
    </div>
</template>

<script>
    import firebase from "firebase";
    import Header from '../src/components/Header';
    import colors from '../src/css/colors.scss'

    export default {
        name: 'App',
        components: {
            Header: Header
        },
        data() {
            return { }
        },


        methods: {
            currentUser: function () {
                return firebase.auth().currentUser;
            },
            setUser: function() {
                this.$store.dispatch('setUser');
            }
        },
        created() {                 // this uses Vuex to check if a user is signed in
            this.setUser();
        }
    }
</script>

<style lang="scss">
    #app, body {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-size: 12pt;
        color: #333;
        font-weight: 500;
        margin: 0;
        padding: 0;
    }

    .divContainer {
        margin: 100px 0 0 0;
        display: flex;
        justify-content: center;
        font-family: 'lato', sans-serif;
        background: white;
        min-width: 100%;
    }

    h3 {
        margin: 5px 0;
        font-weight: 300;
        line-height: 1;
        font-size: 16pt;
        color: #333;
    }

    h4 {
        margin: 5px 0;
        font-weight: 400;
        font-size: 14pt;
    }

    a {
        color: darkgray;
        text-decoration: none;
        cursor: pointer;
    }

    a:hover, a:active, a:focus {
        text-decoration: none;
        /*   outline: #ddd thin dotted;*/
        outline: none;
    }

    p, label, .col-form-label {
        font-size: 10pt;
        font-weight: 300;
        margin: 0;
        padding: 0;
    }

    button:focus {
        border: none;
        outline: none;
    }

    button {
        display: block;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        background: none;
        border: 1px solid transparent;
        border-radius: 2px;
    }

    .buttons {
        margin: 20px 10px;
        display: block;
        text-align: center;
        font-weight: 500;
        padding: 12px 20px;
        border-radius: 2px;
        color: #eee;
        border: 1px solid transparent;
    }

    input.form-control{
        font-size: 10pt;
    }

    .badge {
        border-radius: 2px;
        padding: 2px 3px;
        display: inline;
        font-size: 8pt;
        letter-spacing: -1;
    }
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (max-width: 630px) {
        .row div {
            padding: 1.5%;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (max-width: 992px) {
        h1 {
            margin: 0 0 10px;
            font-size: 22px;
        }

        h3 {
            margin: 5px 0;
            font-size: 14pt;
        }

        h4 {
            margin: 10px 0 5px 0;
            font-size: 16pt;
        }

        @media only screen and (max-width: 1312px) {
            #app {
                font-size: 10pt;
            }
            p, label {
                font-size: 9pt;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue